import { X } from "lucide-react";

const S = "h-7 bg-input border border-border rounded-sm text-[11px] px-1.5 min-w-0";

/** Filtres de l'historique — TOUS appliqués côté backend avec pagination. */
export const FiltresMouvements = ({ f, setF, produits, emplacements, lots, ofs, utilisateurs,
                                    unites, types }) => {
  const up = (k) => (e) => setF({ ...f, [k]: e.target.value || "" });
  const actifs = Object.entries(f).filter(([k, v]) => v && !["page"].includes(k));
  return (
    <div data-testid="filtres-mouvements" className="flex flex-wrap items-end gap-2">
      <label className="flex flex-col gap-0.5">
        <span className="eyebrow">Du</span>
        <input data-testid="f-du" type="date" className={`${S} font-mono`} value={f.du} onChange={up("du")} />
      </label>
      <label className="flex flex-col gap-0.5">
        <span className="eyebrow">Au</span>
        <input data-testid="f-au" type="date" className={`${S} font-mono`} value={f.au} onChange={up("au")} />
      </label>
      <label className="flex flex-col gap-0.5">
        <span className="eyebrow">Type</span>
        <select data-testid="f-type" className={S} value={f.type} onChange={up("type")}>
          <option value="">Tous les types</option>
          {types.map((t) => <option key={t} value={t}>{t.replace(/_/g, " ")}</option>)}
        </select>
      </label>
      <label className="flex flex-col gap-0.5">
        <span className="eyebrow">Produit</span>
        <select data-testid="f-produit" className={S} value={f.produit_id} onChange={up("produit_id")}>
          <option value="">Tous</option>
          {produits.map((p) => <option key={p.id} value={p.id}>{p.code}</option>)}
        </select>
      </label>
      <label className="flex flex-col gap-0.5">
        <span className="eyebrow">Emplacement</span>
        <select data-testid="f-emplacement" className={S} value={f.emplacement_id} onChange={up("emplacement_id")}>
          <option value="">Tous</option>
          {emplacements.map((e) => <option key={e.id} value={e.id}>{e.nom}</option>)}
        </select>
      </label>
      <label className="flex flex-col gap-0.5">
        <span className="eyebrow">Lot</span>
        <select data-testid="f-lot" className={S} value={f.lot_id} onChange={up("lot_id")}>
          <option value="">Tous</option>
          {lots.map((l) => <option key={l.id} value={l.id}>{l.code}</option>)}
        </select>
      </label>
      <label className="flex flex-col gap-0.5">
        <span className="eyebrow">OF</span>
        <select data-testid="f-of" className={S} value={f.of_id} onChange={up("of_id")}>
          <option value="">Tous</option>
          {ofs.map((o) => <option key={o.id} value={o.id}>{o.numero}</option>)}
        </select>
      </label>
      <label className="flex flex-col gap-0.5">
        <span className="eyebrow">Utilisateur</span>
        <select data-testid="f-utilisateur" className={S} value={f.utilisateur_id} onChange={up("utilisateur_id")}>
          <option value="">Tous</option>
          {utilisateurs.map((u) => <option key={u.id} value={u.id}>{u.nom}</option>)}
        </select>
      </label>
      <label className="flex flex-col gap-0.5">
        <span className="eyebrow">Unité</span>
        <select data-testid="f-unite" className={S} value={f.unite} onChange={up("unite")}>
          <option value="">Toutes</option>
          {unites.map((u) => <option key={u} value={u}>{u}</option>)}
        </select>
      </label>
      {!!actifs.length && (
        <button data-testid="f-reset" onClick={() => setF({ du: "", au: "", type: "", produit_id: "",
          emplacement_id: "", lot_id: "", of_id: "", utilisateur_id: "", unite: "" })}
          className="h-7 px-2 text-[11px] border border-border rounded-sm flex items-center gap-1 hover:bg-muted">
          <X className="h-3 w-3" />Réinitialiser les filtres
        </button>
      )}
    </div>
  );
};
